import { render } from "./VueCutterEditor.vue?vue&type=template&id=12220b69&scoped=true"
import script from "./VueCutterEditor.vue?vue&type=script&lang=js"
export * from "./VueCutterEditor.vue?vue&type=script&lang=js"

import "./VueCutterEditor.vue?vue&type=style&index=0&id=12220b69&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12220b69"]])

export default __exports__